import { Dispatch, SetStateAction } from "react";
import {
    DesvalidarReguaController,
    ValidarReguaController,
} from "../../../../../Controllers/Automacao/Regua/GestaoDeRegua/GestaoDeReguaControllers";
import { IRegua } from "../../../../../Interfaces/Automacao/Regua/GestaoDeRegua/GestaoDeReguaInterfaces";

interface IValidacaoRegua {
    IdRegua: string;

    setDadosRegua: Dispatch<SetStateAction<IRegua | undefined>>;
    DadosRegua: IRegua | undefined;
    setFLAG: Dispatch<SetStateAction<boolean>>;
    FLAG: boolean;
}

export default function ValidacaoRegua(props: IValidacaoRegua) {
    return (
        <>
            <div className="d-flex flex-wrap flex-column align-items-center justify-content-center mb-1 mt-4">
                <div className="d-flex flex-wrap flex-row justify-content-center align-items-center mr-1 ">
                    <span className="h8 text-dark-75">
                        Declaro que realizei todos os testes da régua enquanto
                        estava no ambiente de homologação e estou de acordo com
                        a migração para produção. <br />
                        <br />
                        Ciente de que a partir desse momento os clientes
                        receberão mensagens de cobrança de acordo com as
                        configurações previamente validadas. <br />
                        <br />A CAPYS não se responsabiliza por mensagens
                        indevidas ou qualquer ônus oriundo dessa atividade. .
                    </span>
                </div>
                <div className="d-flex flex-wrap flex-row justify-content-center align-items-center mr-1 mt-15">
                    <div className="d-flex justify-content-center align-items-center mr-2">
                        <span
                            className="switch switch-outline switch-sm switch-icon switch-success d-flex"
                            data-toggle="tooltip"
                        >
                            <label>
                                {props.DadosRegua?.FL_VALIDADO ? (
                                    <input
                                        checked={props.DadosRegua?.FL_VALIDADO}
                                        type="checkbox"
                                    />
                                ):(
                                    <input
                                        onChange={(e) => {
                                            props.setFLAG(e.target.checked);
                                        }}
                                        type="checkbox"
                                    />
                                )}
                                <span></span>
                            </label>
                        </span>
                    </div>
                    <div className="d-flex justify-content-center align-items-center">
                        <h1 className="font-weight-bolder font-size-normal d-flex justify-content-center m-0">
                            <span className="h8 text-dark-75 ">
                                Informo que li o Termo de Responsabilidade e
                                validei as informações da Régua de Cobrança.
                            </span>
                        </h1>
                    </div>
                </div>
            </div>
            {props.DadosRegua?.FL_VALIDADO ? (
                <div className="d-flex flex-wrap flex-row justify-content-end align-items-center mr-1 mt-8">
                    <button
                        className="btn btn-light-warning border border-warning font-weight-bold m-1"
                        disabled={!props.FLAG}
                        onClick={() => {
                            DesvalidarReguaController(
                                Number.parseInt(props.IdRegua)
                            );
                        }}
                    >
                        Voltar Régua Para Homologação
                    </button>
                </div>
            ) : (
                <div className="d-flex flex-wrap flex-row justify-content-end align-items-center mr-1 mt-8">
                    <button
                        className="btn btn-light-success border border-success font-weight-bold m-1"
                        disabled={!props.FLAG}
                        onClick={() => {
                            ValidarReguaController(
                                Number.parseInt(props.IdRegua)
                            );
                        }}
                    >
                        Enviar Para Produção
                    </button>
                </div>
            )}
        </>
    );
}
